// utils/timeFormat.js
export const formatTimeDisplay = (time, day) => {
    // Handle closing times
    if (time !== "Not Available" || time !== "Requested Off") {
        var notime = true;
        const [hours24, minutes] = time.split(':').map(Number);

        const ampm = hours24 >= 12 ? 'PM' : 'AM';

        let hours12 = hours24 % 12;
        if (hours12 === 0) {
            hours12 = 12;
        }

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    }

    if ((['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Sunday'].includes(day) && time === '9:00PM') ||
        (['Friday', 'Saturday'].includes(day) && time === '10:00PM')) {
        return 'Close';
    } else if (notime) {
        return time;
    } else {
        return `${hours12}:${formattedMinutes}${ampm}`;
    }
    //return time;
};